import { useParams } from 'react-router-dom'
import { isReserved } from '@/lib/reserved'
import ColorPage from './ColorPage'
import CertificatePage from './CertificatePage'
import Merch from './Merch'
import NotFound from './NotFound'

/**
 * /:slug shortcut for color pages (colormark.org/blue), plus /:slug/certificate
 * and /:slug/merch. Reserved words and site routes never resolve to a color.
 */
export default function SlugResolver({ view = 'color' }: { view?: 'color' | 'certificate' | 'merch' }) {
  const { slug = '' } = useParams<{ slug: string }>()
  if (isReserved(slug)) return <NotFound />
  if (view === 'certificate') return <CertificatePage slug={slug} />
  if (view === 'merch') return <Merch />
  return <ColorPage slug={slug} />
}
